import { Component, Input } from '@angular/core';

import { RatingSizeEnum } from '~/component/vtmn-rating/enums/RatingSize.enum';

@Component({
  selector: 'app-global-review',
  templateUrl: './global-review.component.html',
  styleUrls: ['./global-review.component.scss'],
})
export class AttendeeGlobalReviewComponent {
  @Input() public globalNote: number;
  @Input() public title: string;
  @Input() public totalReviews: string;

  public ratingSize = RatingSizeEnum.SMALL;

  get roundedGlobalNote(): number {
    return Math.round(this.globalNote * 10) / 10 || 0;
  }
}
